//LIBRARIES
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import camelCase from 'lodash/camelCase';
import { SyncLoader } from 'halogenium';
import { List, Button } from 'antd';

//ACTION
import {
  deleteLeaseDocument,
  getLeaseDocuments,
  getPropertyDocuments,
} from 'actions/landlordTenantsActions';

//COMPONENTS
import Collapsible from 'components/shared/Collapsible';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';

//HELPERS
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

//STYLING

const LEASE_MODE = 'lease';
const UNIT_MODE = 'unit';
const PROPERTY_MODE = 'property';
const LEAD_MODE = 'lead';

let Documents = connect(
  (store) => {
    return {
      leaseDetails: store.leaseDetails.leaseDetails,
      unitId: store.landlordTenants.unitId,
      propertyId: store.landlordTenants.propertyId,
      leaseId:
        store.landlordTenants.tenantDetails?.active_lease_id ||
        store.landlordTenants.tenantDetails?.lease?.id ||
        store.landlordTenants.leaseDetails?.id,
      cotenantId: store.landlordTenants.cotenantId,
      displayMode: store.landlordTenants.displayMode,
      documents: store.landlordTenants.documents,
      showLoadingDocuments: store.landlordTenants.showLoadingDocuments,
    };
  },
  { deleteLeaseDocument, getLeaseDocuments, getPropertyDocuments }
)(
  class Documents extends Component {
    constructor(props) {
      super(props);
      this.state = {
        deleteDocumentConfirmationDialogOpen: false,
        selectedDocumentId: null,
        selectedDocumentName: '',
      };
    }

    componentDidMount = () => {
      if (this.props.displayMode === LEASE_MODE) {
        this.props.getLeaseDocuments(this.props.leaseDetails.id);
      } else if (this.props.displayMode === UNIT_MODE) {
        this.props.getUnitDocuments(this.props.unitId);
      } else if (this.props.displayMode === LEAD_MODE) {
        this.props.getLeadDocuments(this.props.cotenantId);
      } else if (this.props.displayMode === PROPERTY_MODE) {
        this.props.getPropertyDocuments(this.props.propertyId);
      }
    };

    onDocDeleteConfirmationClick = (document) => {
      this.setState({
        deleteDocumentConfirmationDialogOpen: true,
        selectedDocumentName: document.document_name,
        selectedDocumentId: document.document_id,
      });
    };

    resetSelectedDocuments = () => {
      this.setState({
        deleteDocumentConfirmationDialogOpen: false,
        selectedDocumentName: '',
        selectedDocumentId: null,
      });
    };

    confirmDeleteDocument = async (leaseId, documentId) => {
      const { getLeaseDocuments, deleteLeaseDocument } = this.props;
      try {
        await deleteLeaseDocument(leaseId, documentId);
        getLeaseDocuments(leaseId);
      } catch (err) {
        console.error(err);
      }
      this.resetSelectedDocuments();
    };

    renderActionButtons(document, label) {
      let actionButtons = [
        <a
          key="download-document"
          rel="noopener noreferrer"
          href={document.document_url}
          target="_blank"
        >
          {getTranslatedString('download')}
        </a>,
      ];

      if (label === 'Others') {
        actionButtons.unshift(
          <Button
            type="link"
            onClick={() => {
              this.onDocDeleteConfirmationClick(document);
            }}
            style={{ color: colors.RED, height: '24px', padding: '0px' }}
          >
            {getTranslatedString('delete')}
          </Button>
        );
      }

      return actionButtons;
    }

    createDocuments = (documents, label) => {
      const style = {
        header: {
          fontSize: '15px',
          marginTop: '10px',
        },
        bold_padding: {
          padding: '0px 5px',
          fontWeight: '800',
        },
        padding_right: {
          padding: '0px 5px',
          fontWeight: '800',
        },
      };

      return (
        <Collapsible
          header={
            <div className="row" style={style.header}>
              <div className="col-xs-12" style={style.bold_padding}>
                <p id="no-margin">{this.props.translate(`docType.${camelCase(label)}`)}</p>
              </div>
            </div>
          }
        >
          <List
            bordered
            dataSource={documents}
            renderItem={(document) => {
              return (
                <List.Item actions={this.renderActionButtons(document, label)}>
                  {document.document_name}
                </List.Item>
              );
            }}
          />
        </Collapsible>
      );
    };

    displayDocument = (type) => {
      const type_documents = this.props.documents.filter((d) => {
        return d.document_type === type;
      });
      return (
        <div>{type_documents.length > 0 && this.createDocuments(type_documents, `${type}`)}</div>
      );
    };

    displayOthersDocument = (types) => {
      const other_type_documents = this.props.documents.filter((d) => {
        return types.includes(d.document_type) === false;
      });

      return (
        <div>
          {other_type_documents.length > 0 && this.createDocuments(other_type_documents, 'Others')}
        </div>
      );
    };

    displayDocuments = () => {
      const types = [
        'Certificate of Service',
        'Inspection Report',
        'Lease',
        'Notice',
        'Renters Insurance',
        'Termination Agreement',
        'Renewal',
        'Renewal Notice of Increase',
        'Renewal Certificate of Service',
        'Other',
      ];
      const documents = types.map((type) => {
        return <div> {this.displayDocument(type)} </div>;
      });

      documents.push(<div> {this.displayOthersDocument(types)} </div>);

      return documents;
    };

    render() {
      const { deleteDocumentConfirmationDialogOpen, selectedDocumentId, selectedDocumentName } =
        this.state;
      const { showLoadingDocuments, documents, translate, leaseId } = this.props;
      return (
        <div>
          <ConfirmationDialog
            showDialog={deleteDocumentConfirmationDialogOpen}
            hideDialog={() => this.resetSelectedDocuments()}
            userConfirmVerbiage={getTranslatedString('landlordPortal.tenantOverview.delete')}
            userConfirmAction={() => this.confirmDeleteDocument(leaseId, selectedDocumentId)}
            dialogTitle={getTranslatedString('landlordPortal.tenantOverview.documentDeleteTitle')}
            dialogBodyVerbiage={
              <span>
                {getTranslatedString('landlordPortal.tenantOverview.documentDeleteDescription', {
                  name: selectedDocumentName,
                })}
              </span>
            }
          />
          <div className="row" style={{ marginTop: '-10px' }}>
            {showLoadingDocuments && (
              <div style={{ position: 'relative', top: '30%', zIndex: '500' }}>
                <p
                  style={{
                    textAlign: 'center',
                    marginTop: '5%',
                  }}
                >
                  <SyncLoader color="#ff5656" size="16px" margin="4px" />
                </p>
              </div>
            )}
            {documents && documents.length > 0 && (
              <div className="row" style={{ padding: '5px 0' }}>
                {this.displayDocuments()}
              </div>
            )}
            {!showLoadingDocuments && documents.length === 0 && (
              <div style={{ textAlign: 'center', marginTop: '25px' }}>
                {' '}
                {translate('landlordPortal.documents.noDocument')}{' '}
              </div>
            )}
          </div>
        </div>
      );
    }
  }
);

export default localize()(Documents);
